import React, { InputHTMLAttributes, memo } from "react";
import cn from "classnames";
import styles from "./checkbox.module.scss";

export interface CheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: React.ReactNode;
  labelClass?: string;
  subLabel?: string;
  name: string;
  /**
   * Optional explicit id to use for the underlying input/label.
   * Falls back to `name` when not provided.
   */
  id?: string;
  error?: string;
  disabled?: boolean;
  subLabelClass?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckBoxProps>(
  (
    {
      className,
      label,
      labelClass,
      name,
      id,
      subLabel,
      error,
      disabled,
      subLabelClass,
      ...rest
    },
    ref
  ) => {
    const resolvedId = id || name;

    return (
      <div className={className}>
        <div className="flex items-center">
          <input
            id={resolvedId}
            name={name}
            type="checkbox"
            // style={{ display: "none" }}
            ref={ref}
            className={styles.checkbox}
            disabled={disabled}
            {...rest}
          />

          <label htmlFor={resolvedId} className={cn("text-white font-light text-sm14  ", labelClass)}>
            {/* {label && label?.toString()?.slice(0, 15) + (label?.toString()?.length > 15 ? "..." : "")} */}
            {label}
          </label>
        </div>
        {subLabel && (
          <div
            className={`flex justify-start text-black ml-8 text-sm mt-2 ${subLabelClass}`}
          >
            {subLabel}
          </div>
        )}
        {error && <p className="my-2 text-xs text-end text-red-500">{error}</p>}
      </div>
    );
  }
);

export default memo(Checkbox);
